import Image from 'next/legacy/image';
import React from 'react';
import { BodyRegular, H1 } from '@components/atoms/typography';
import Button from '@components/atoms/button';

const UserNotFoundError = () => {
  return (
    <div className="flex flex-col items-center py-10 px-5 max-w-[700px] mx-auto">
      <Image
        src="/images/fpl-logo-large.svg"
        height={100}
        width={500}
        alt="Page error image"
        className="rounded-lg"
      />
      <H1 className="text-center mt-6 mb-2">Team not found</H1>
      <BodyRegular className="text-center mt-1">
        We couldn't find your team. Your team will only be accessible the
        gameweek after it was created.
      </BodyRegular>
      <BodyRegular className="text-center mt-1">
        Please don't create a support ticket for this, just wait until the next
        gameweek.
      </BodyRegular>
      <Button href="/my-team/points" isLink variant="primary" className="mt-5">
        Go back
      </Button>
    </div>
  );
};

export default UserNotFoundError;
